import { render, staticRenderFns } from "./huotiDetail.vue?vue&type=template&id=5ee16d3c&scoped=true&"
import script from "./huotiDetail.vue?vue&type=script&lang=js&"
export * from "./huotiDetail.vue?vue&type=script&lang=js&"
import style0 from "./huotiDetail.vue?vue&type=style&index=0&id=5ee16d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee16d3c",
  null
  
)

export default component.exports